import React from 'react';
import { HeartPulseIcon, ActivityIcon, LineChartIcon } from 'lucide-react';
export const BodySection: React.FC = () => {
  return <section className="py-16 md:py-24 bg-cloud" data-id="element-17">
      <div className="section-container" data-id="element-18">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-19">
          <div className="space-y-6" data-id="element-20">
            <h2 className="text-3xl md:text-4xl font-literata font-medium text-deep-juniper" data-id="element-21">
              Your body tells a story — we listen
            </h2>
            <p className="text-lg text-plum-gray leading-relaxed" data-id="element-22">
              Your biometric signals — heart rate, sleep, activity — are
              securely integrated into your care, helping therapists adapt
              sessions to your body's needs.
            </p>
          </div>
          <div className="flex items-center justify-center" data-id="element-23">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wvcaqxDKyp9WjZpo3GnZAm/connections_paths_light.svg" alt="Two human figures composed of dotted connection paths, representing the integration of biometric data and human experience" className="w-full max-w-md" data-id="element-24" />
          </div>
        </div>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-25">
          <div className="card bg-mist-sage/20" data-id="element-26">
            <div className="flex items-center space-x-4 mb-4" data-id="element-27">
              <div className="w-10 h-10 rounded-full bg-mist-sage/40 flex items-center justify-center" data-id="element-28">
                <HeartPulseIcon className="text-deep-juniper" size={20} data-id="element-29" />
              </div>
              <h3 className="text-lg font-medium text-deep-juniper" data-id="element-30">
                Heart Rate & Vagus
              </h3>
            </div>
            <p className="text-plum-gray" data-id="element-31">
              Tracks stress patterns and autonomic nervous system responses to
              help identify triggers and recovery.
            </p>
          </div>
          <div className="card bg-apricot/10" data-id="element-32">
            <div className="flex items-center space-x-4 mb-4" data-id="element-33">
              <div className="w-10 h-10 rounded-full bg-apricot/30 flex items-center justify-center" data-id="element-34">
                <ActivityIcon className="text-deep-juniper" size={20} data-id="element-35" />
              </div>
              <h3 className="text-lg font-medium text-deep-juniper" data-id="element-36">
                Therapy Correlations
              </h3>
            </div>
            <p className="text-plum-gray" data-id="element-37">
              Links physiological data to therapy progress, showing what
              approaches are most effective for you.
            </p>
          </div>
          <div className="card bg-plum-gray/10" data-id="element-38">
            <div className="flex items-center space-x-4 mb-4" data-id="element-39">
              <div className="w-10 h-10 rounded-full bg-plum-gray/30 flex items-center justify-center" data-id="element-40">
                <LineChartIcon className="text-deep-juniper" size={20} data-id="element-41" />
              </div>
              <h3 className="text-lg font-medium text-deep-juniper" data-id="element-42">
                Continual Support
              </h3>
            </div>
            <p className="text-plum-gray" data-id="element-43">
              Adapts between sessions to provide the right level of support when
              you need it most.
            </p>
          </div>
        </div>
      </div>
    </section>;
};